import { Outlet } from 'react-router-dom';
import { MegaMenu } from './header/MegaMenu';
import { ScrollToTop } from './ScrollToTop';

/** 헤더만 있고 푸터가 없는 라우트 레이아웃 */
export const HeaderOnlyLayout = () => {
  return (
    <>
      <MegaMenu />
      <main className="mt-[58px]">
        <ScrollToTop>
          <Outlet />
        </ScrollToTop>
      </main>
    </>
  );
};
